import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04f9fae5")

_pushScopeId("data-v-04f9fae5")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "topbar-main" }, [
  /*#__PURE__*/_createVNode("div", { class: "container" }, [
    /*#__PURE__*/_createVNode("div", { class: "row" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-12 topbar" }, [
        /*#__PURE__*/_createVNode("i", { class: "icon_lg fal fa-info-circle fa-lg" }),
        /*#__PURE__*/_createVNode("span", { class: "barMsg" }, "You do not have permission to access Committee Member")
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-main" }, [
  /*#__PURE__*/_createVNode("div", { class: "container" }, [
    /*#__PURE__*/_createVNode("div", { class: "row" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-12 content_main_wrap" }, [
        /*#__PURE__*/_createVNode("div", { class: "content_ls_margin" }, [
          /*#__PURE__*/_createVNode("h3", null, "Recruitment for Law Society Committees"),
          /*#__PURE__*/_createVNode("ol", null, [
            /*#__PURE__*/_createVNode("li", null, [
              /*#__PURE__*/_createTextVNode("The Committee Member application can only be accessed by current Committee Members, except when Expressions of Interest for joining a committee is open. If you believe this message is shown to you in error please contact the Executive Unit by email "),
              /*#__PURE__*/_createVNode("a", {
                class: "long_email",
                href: "mailto:councilsupportunit@lawsociety.com.au"
              }, "councilsupportunit@lawsociety.com.au"),
              /*#__PURE__*/_createTextVNode(" or telephone on 02 9926 0358. ")
            ]),
            /*#__PURE__*/_createVNode("li", null, [
              /*#__PURE__*/_createTextVNode("Return to "),
              /*#__PURE__*/_createVNode("a", { href: "https://www.lawid.com.au" }, "My Account")
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_StdPageLayout = _resolveComponent("StdPageLayout")

  return (_openBlock(), _createBlock(_component_StdPageLayout, null, {
    "body-content": _withId(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
})